import React from 'react'
import clogo from '../assests/kredbharat.png'


export default function CustomerList() {
   
    const logos = [
        "./sot-logo.webp",
       
        
       

    ];

    return (
        <div className='mx-auto max-w-3xl pt-12 pb-10'>  
        <h4 className='text-lg leading-snug mb-4 text-center font-semibold text-[#00bd86]'> Our customers</h4>   
        <p className='text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4 text-center'>Partnerships Built on Trust</p>       
            <div className="">
                {logos.map((logo, index) => (
                    <div
                        key={index}
                        className=" bg-white  p-2" style={{height:'100px'}}
                    >
                        <img
                            src={logo}
                            alt="company logo"
                            className="object-contain border rounded-lg p-3" style={{width:'250px', margin:'0 auto'}}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
